import { render, staticRenderFns } from "./Appraisal.vue?vue&type=template&id=0f50565f&scoped=true"
import script from "./Appraisal.vue?vue&type=script&lang=js"
export * from "./Appraisal.vue?vue&type=script&lang=js"
import style0 from "./Appraisal.vue?vue&type=style&index=0&id=0f50565f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f50565f",
  null
  
)

export default component.exports